import React from "react";
import "./button_gradient.scss";

const Button_Gradient = ({ textContent, hrefLink, downloadOptions }) => {
  return (
    <button>
      {hrefLink ? (
        <a href={hrefLink} download={downloadOptions}>
          {textContent}
        </a>
      ) : (
        textContent
      )}
    </button>
  );
};

export default Button_Gradient;
